import { useEffect } from 'react'

// Плавное появление при первой загрузке - имитация сворачивания таблицы
export function useInitialMountAnimationEffect(
  isInitialMount: boolean,
  leftColumnRef: React.RefObject<HTMLDivElement>,
  detailContentRef: React.RefObject<HTMLDivElement>,
  setIsInitialMount: React.Dispatch<React.SetStateAction<boolean>>,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
) {
  useEffect(() => {
    if (isInitialMount) {
      // Начинаем с полной ширины (как таблица) - видимой
      if (leftColumnRef.current) {
        leftColumnRef.current.style.width = '100%'
        leftColumnRef.current.style.opacity = '1'
      }
      if (detailContentRef.current) {
        detailContentRef.current.style.opacity = '0'
        detailContentRef.current.style.transform = 'translateX(100px)'
      }

      // Плавно сворачиваем в левую колонку (25%) и показываем детали справа
      // Используем двойной requestAnimationFrame для гарантии, что DOM обновлен
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setTimeout(() => {
            if (leftColumnRef.current) {
              leftColumnRef.current.style.width = '25%'
            }
            if (detailContentRef.current) {
              detailContentRef.current.style.opacity = '1'
              detailContentRef.current.style.transform = 'translateX(0)'
            }
            // Завершаем анимацию через 500ms (длительность transition)
            setTimeout(() => {
              setIsInitialMount(false)
              setLoading(false)
            }, 500)
          }, 50)
        })
      })
    }
  }, [isInitialMount, leftColumnRef, detailContentRef, setIsInitialMount, setLoading])
}
